import React from 'react';

const Page = ({ children, fullWidth = false, title, subtitle }) => {
  return (
    <div className={`page-wrapper ${fullWidth ? 'full-width' : ''}`}>
      {title && (
        <div className="page-header">
          <h1 className="page-title">{title}</h1>
          {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>
      )}
      <div className="page-content">
        {children}
      </div>
    </div>
  );
};

export default Page;